import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7Z" />
                    <rect x="33.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M92.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S63.4,99.8,66,104.5s10.7,5.4,18,1.6S94.9,95.4,92.2,90.7Z" />
                    <rect x="91.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M129.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4,10.7,5.4,18,1.6S131.9,95.4,129.2,90.7Z" />
                    <rect x="128.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="33" y="23" width="97" height="10" />
                <rect x="91" y="37" width="39" height="10" />
            </g>
        </svg>
    );
}
